import React from 'react';
import { connect } from 'react-redux';
import { FileDownloader } from '@beef/ui-kit';
import PropTypes from 'prop-types';
import { getDeviceDocumentation } from "../../../../store/blocks/devices/selectors";
var _DeviceDocumentation = function _DeviceDocumentation(_ref) {
  var documentation = _ref.documentation;
  return /*#__PURE__*/React.createElement(React.Fragment, null, documentation.map(function (element) {
    return /*#__PURE__*/React.createElement(FileDownloader, {
      href: element.url,
      key: element.text,
      text: element.text,
      "data-t-id": "components-DeviceDocumentation"
    });
  }));
};
_DeviceDocumentation.propTypes = process.env.NODE_ENV !== "production" ? {
  documentation: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string
  }))
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    documentation: getDeviceDocumentation(state)
  };
};
export var DeviceDocumentation = connect(mapStateToProps)(_DeviceDocumentation);